import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import CurFt from "../../components/CurFt";
import { useNavigate } from 'react-router-dom';
// const data = {
//     domestic: [
//         { title: "Manali", price: "₹ 23,000", image: "/images/south-india-handpckd.webp" },
//         { title: "Vietnam", price: "₹ 14,499", image: "/images/south-india-handpckd.webp" },
//         { title: "Europe", price: "₹ 88,990", image: "/images/south-india-handpckd.webp" },
//         { title: "Australia", price: "₹ 41,990", image: "/images/south-india-handpckd.webp" }
//     ],
//     international: [
//         { title: "Thailand", price: "₹ 29,999", image: "/images/south-india-handpckd.webp" },
//         { title: "Bali", price: "₹ 34,999", image: "/images/south-india-handpckd.webp" },
//         { title: "Maldives", price: "₹ 59,999", image: "/images/south-india-handpckd.webp" },
//         { title: "Sri Lanka", price: "₹ 19,999", image: "/images/south-india-handpckd.webp" }
//     ]
// };

const CARD_WIDTH = 280;

const HandpickedPackages = ({ results, loading }) => {
    const navigate = useNavigate();
    const data = {
        domestic: results
            .filter(item => item.PackageType === 0)
            .map(item => ({
                id: item.id,
                title: item.PackageName,
                price: <CurFt currency={item.currency.name || 'INR'} price={Math.ceil(parseFloat(item.categories?.[0]?.finalPrice || 0))} />,
                image: item.Photo,
                des_city_name: item.des_city_name,
                inclusion_names: item.inclusion_names,
                PackageDuration: item.PackageDuration,
                SearchId: item.SearchId,
                pack_cat_id: item.categories?.[0]?.pack_cat_id,
                rate_card_group: item.categories?.[0]?.rate_card_group,
                hotelOptions: item.categories?.[0]?.hotelOptions,
            })),

        international: results
            .filter(item => item.PackageType === 1)
            .map(item => ({
                id: item.id,
                title: item.PackageName,
                price: <CurFt currency={item.currency.name || 'INR'} price={Math.ceil(parseFloat(item.categories?.[0]?.finalPrice || 0))} />,
                image: item.Photo,
                des_city_name: item.des_city_name,
                inclusion_names: item.inclusion_names,
                PackageDuration: item.PackageDuration,
                SearchId: item.SearchId,
                pack_cat_id: item.categories?.[0]?.pack_cat_id,
                rate_card_group: item.categories?.[0]?.rate_card_group,
                hotelOptions: item.categories?.[0]?.hotelOptions,
            }))
    };
    const [tab, setTab] = useState("domestic");
    const trackRef = useRef(null);
    const position = useRef(0);

    const items = [...data[tab], ...data[tab]];

    const move = (dir = 1) => {
        position.current += CARD_WIDTH * dir;

        if (position.current >= data[tab].length * CARD_WIDTH) {
            position.current = 0;
        }
        if (position.current < 0) {
            position.current = data[tab].length * CARD_WIDTH;
        }

        trackRef.current.style.transform = `translateX(-${position.current}px)`;
    };

    // Auto scroll
    useEffect(() => {
        position.current = 0;
        if (trackRef.current) {
            trackRef.current.style.transform = "translateX(0px)";
        }

        const interval = setInterval(() => move(1), 3500);
        return () => clearInterval(interval);
    }, [tab]);

    const onCardClick = (item) => {
        alert(`Navigate to ${item.title} packages`);
    };
    const LoadingSkeleton = () => (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[...Array(4)].map((_, index) => (
                <div
                    key={index}
                    className="bg-white rounded-2xl shadow-sm overflow-hidden animate-pulse"
                >
                    {/* Image */}
                    <div className="w-full h-[180px] bg-gray-200"></div>

                    {/* Content */}
                    <div className="p-5">
                        {/* Destination */}
                        <div className="h-5 bg-gray-200 rounded-md w-28 mb-3"></div>

                        {/* Price */}
                        <div className="h-4 bg-gray-200 rounded-md w-24 mb-5"></div>

                        {/* Explore */}
                        <div className="h-4 bg-gray-200 rounded-md w-20"></div>
                    </div>
                </div>
            ))}
        </div>
    );
    return (
        <section className="max-w-7xl mx-auto px-4 overflow-hidden">
            <h2 className="text-4xl font-bold">Handpicked Holiday Packages</h2>
            <p className="text-gray-500 mb-4">
                Indulge in unforgettable adventure with special tour plans.
            </p>

            {/* Tabs */}
            <div className="flex gap-3 mb-6">
                {["domestic", "international"].map((t) => (
                    <button
                        key={t}
                        onClick={() => setTab(t)}
                        className={`px-5 py-2 rounded border ${tab === t
                            ? "border-blue-500 text-blue-600"
                            : "text-gray-500"
                            }`}
                    >
                        {t.charAt(0).toUpperCase() + t.slice(1)}
                    </button>
                ))}
            </div>
            {loading ? (
                <><LoadingSkeleton /></>
            ) : (
                <>

                    {/* Carousel */}
                    <div className="relative">
                        {/* LEFT */}
                        <button
                            onClick={() => move(-1)}
                            className="absolute -left-4 top-1/2 -translate-y-1/2 bg-white shadow p-2 rounded-full z-10"
                        >
                            <ChevronLeft />
                        </button>

                        {/* VIEWPORT */}
                        <div className="overflow-hidden" style={{ padding: '5px' }}>
                            <div
                                ref={trackRef}
                                className="flex gap-6 transition-transform duration-700 ease-in-out"
                                style={{ width: "max-content" }}
                            >
                                {items.map((item, i) => (
                                    <div
                                        key={i}
                                        onClick={() => onCardClick(item)}
                                        onClick={() =>
                                            navigate(
                                                `/Holidays/details/${item.id}?cat=${item.pack_cat_id}&ratecard=${item.rate_card_group}&SearchId=${item.SearchId}&hotelOptions=${JSON.stringify(item.hotelOptions)}`
                                            )}
                                        className="w-[260px] bg-white rounded-xl shadow cursor-pointer"
                                    >
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            onError={(e) => {
                                                e.target.onerror = null; // prevent infinite loop
                                                e.target.src = "/placeholder.png"; // path to your placeholder image
                                            }}
                                            className="h-44 w-full object-cover rounded-t-xl"
                                        />
                                        <div className="p-4">
                                            <h3 className="font-semibold">{item.des_city_name}</h3>
                                            <h3 className="font-semibold">{item.PackageDuration} Nights / {parseInt(item.PackageDuration) + 1} Days</h3>
                                            <p className="text-sm text-gray-500 font-semibold">
                                                Included :<span className="font-normal text-green-600">{item.inclusion_names?.split(',')}</span>
                                            </p>
                                            {/* <p className="text-sm text-gray-500">
                                                Start From <span className="font-medium">{item.price}</span>
                                            </p> */}
                                            <button className="text-blue-600 text-sm mt-2">
                                                Explore →
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* RIGHT */}
                        <button
                            onClick={() => move(1)}
                            className="absolute -right-4 top-1/2 -translate-y-1/2 bg-white shadow p-2 rounded-full z-10"
                        >
                            <ChevronRight />
                        </button>
                    </div>
                </>
            )}

        </section>
    );
};

export default HandpickedPackages;